const e = {
  name: "Heart",
  dimensions: { width: 40, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39.9 38.2" style="enable-background:new 0 0 39.9 38.2;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M37.1,3.7c-2-2.2-4.7-3.5-7.6-3.7c-3.8-0.2-7.4,1.6-9.5,4.7c-2.1-3.1-5.7-4.8-9.5-4.7
			C7.6,0.1,4.9,1.4,2.9,3.7C0.8,6.1-0.2,9.3,0,12.5c1.2,14,18.7,24.9,19.4,25.3l0.5,0.3l0.5-0.3c0.7-0.5,18.2-11.3,19.4-25.3
			C40.2,9.3,39.1,6.1,37.1,3.7L37.1,3.7z M37.9,12.3c-1,11.7-15,21.6-17.9,23.5C17.1,33.9,3.1,24.1,2,12.3C1.8,9.7,2.7,7,4.4,5
			C6,3.2,8.2,2.1,10.6,2c0.1,0,0.3,0,0.4,0c3.4,0,6.6,2,8.1,5.1L20,9l0.9-1.9c1.6-3.3,4.9-5.2,8.5-5.1c2.4,0.1,4.5,1.2,6.2,3
			C37.3,7,38.2,9.7,37.9,12.3L37.9,12.3z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Heart
};
